export default __webpack_public_path__ + "static/media/side_bar_top.min.29833cec.png";